import React from 'react';

import Avatar from './AvatarContainer';
import Icons from 'components/Icons';
import Card from 'components/common/Card';

import {
  Link,
  AppBarLogo,
  AppBarFlex,
  AppBarInner,
  AppBarDisplay,
  AppBarBackButton
} from './NavBarStyled';

export const NavBar = ({
  user,
  title,
  showBack,
  hideShadow,
  onBackClick,
  notifications,
  onLogoutClick,
  onContactClick,
  onConnectionsClick
}) => (
  <AppBarDisplay hideShadow={hideShadow}>
    <AppBarInner>
      <AppBarFlex>
        {showBack && (
          <AppBarBackButton onClick={onBackClick}>
            <Icons.Back size={32} />
          </AppBarBackButton>
        )}

        {!showBack && <AppBarLogo />}
        <Card.Title>{title}</Card.Title>
      </AppBarFlex>

      {notifications}
      <Link onClick={onConnectionsClick}>Connections</Link>
      <Link onClick={onContactClick}>Contact Us</Link>
      <Avatar 
        user={user}
        onLogoutClick={onLogoutClick} 
        onContactClick={onContactClick}
      />
    </AppBarInner>
  </AppBarDisplay>
);

export default NavBar;
